<template>
  <div style="padding: 30px;">
    <template v-if="error">
      {{ $t("auth.logout.error") }}
    </template>

    <template v-else>
      {{ $t("auth.logout.title") }}
    </template>
  </div>
</template>

<script>
import apiUser from "@/api/user";

export default {
  data: () => ({
    error: false
  }),

  created() {
    apiUser
      .logout()
      .then(() => {
        if (window.Echo)
          window.Echo.connector.options.auth.headers["Authorization"] =
            "Bearer null";
        this.$store.dispatch("auth/logout");
      })
      .catch(() => {
        this.error = true;
      });
  }
};
</script>
